import JWT from '@/utils/jwt'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  // isLoggedIn: !!JWT.getAccessToken() || false,
  user: {},
  errors: [],
  isLoading: false,
  isAccFreeLogout: false,
  loginPopupData: {},
  isOpenLoginForm: false,
  isOpenLoginFormSSO: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}